import { IAudienceMembersList } from './types';
import { Avatar, Grid, Typography } from '@mui/material';
import { getImageBySize } from 'utils/helpers';
import DefaultAvatar from 'components/default-avatar';
import { styles } from './styles';

export const AudienceMembersList = ({ members }: IAudienceMembersList) => {
  return (
    <Grid>
      {members.map(({ firstName, lastName, avatar, id }) => (
        <Grid sx={styles.memberConatiner} key={id}>
          {avatar ? (
            <Avatar
              alt="avatar"
              sx={styles.userAvatar}
              src={getImageBySize(avatar, 36, 36)}
              variant="square"
            />
          ) : (
            <DefaultAvatar
              initials={firstName && lastName ? `${firstName[0]}${lastName[0]}` : ''}
              variant="square"
              alt="avatar"
              sx={styles.defaultAvatar}
            />
          )}
          <Typography sx={styles.userName}>{`${firstName} ${lastName}`}</Typography>
        </Grid>
      ))}
    </Grid>
  );
};
